import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["blockSize", "data", "inlineSize", "isLoading", "loadingDataOptions", "name"];
import { useMemo } from 'react';
// @ts-expect-error highcharts@7 is not typed

import { ReactHighcharts } from './ReactHighcharts/ReactHighcharts';
import { LayoutBox } from '../Layout/LayoutBox';
import { randomLoadingData } from './randomLoadingData';
import { useTokens } from '../useTokens';
import { jsx as _jsx } from "react/jsx-runtime";
export const ChartTrend = _ref => {
  let {
      blockSize = '44px',
      data,
      inlineSize = '100%',
      isLoading = false,
      loadingDataOptions,
      name
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    tokens
  } = useTokens();
  const {
    dataViz
  } = tokens;
  const loadingData = useMemo(() => randomLoadingData(loadingDataOptions !== null && loadingDataOptions !== void 0 ? loadingDataOptions : {}), [loadingDataOptions]);
  const series = useMemo(() => [{
    color: isLoading ? dataViz.disabled : dataViz.dataViz1,
    data: isLoading ? loadingData : data,
    fillOpacity: 0.3,
    name,
    type: 'area'
  }],
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [data, name]);
  const chartOptions = {
    chart: {
      height: blockSize,
      margin: [0, 0, 0, 0],
      type: 'area'
    },
    credits: {
      enabled: false
    },
    xAxis: {
      endOnTick: false,
      startOnTick: true,
      tickColor: 'transparent',
      maxPadding: 0,
      tickPositions: [0]
    },
    yAxis: {
      startOnTick: false,
      endOnTick: false,
      tickPositions: [0]
    },
    legend: {
      enabled: false
    },
    tooltip: {
      enabled: false
    },
    plotOptions: {
      series: {
        lineWidth: 2,
        marker: {
          enabled: false
        },
        states: {
          hover: {
            enabled: false
          }
        }
      }
    },
    series
  };
  return /*#__PURE__*/_jsx(LayoutBox, Object.assign({}, rest, {
    blockSize: blockSize,
    inlineSize: inlineSize,
    children: /*#__PURE__*/_jsx(ReactHighcharts, {
      options: chartOptions
    })
  }));
};